export const GLOBALS = {
  COLORS: {
    PRIMARY_COLOR: "#fe5000",
    SECONDARY_COLOR: "#ffa000",
  },
};
